export default "__VITE_ASSET__BrdF_aub__"